import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2a024bd8&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=2a024bd8&lang=scss"
import style1 from "./Index.vue?vue&type=style&index=1&id=2a024bd8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a024bd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a024bd8')) {
      api.createRecord('2a024bd8', component.options)
    } else {
      api.reload('2a024bd8', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=2a024bd8&scoped=true", function () {
      api.rerender('2a024bd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/player/Index.vue"
export default component.exports